interface IPixel {
  content_id: number;
  content_type: number;
  created_at: string;
  google_conversion_label: string;
  id: number;
  pixel_code: string;
  status: string;
  track_boleto: boolean;
  track_checkout: boolean;
  track_credit_card: boolean;
  track_view_content: boolean;
  tracking_level: string;
  type: string;
  updated_at: string;
}

interface ILangs {
  code: string;
  id: number;
  image_url: string;
  name: string;
}

export interface IAdvancedTheme {
  themeBlogThumbnails: string;
  themeBundleThumbnails: string;
  themeBuyButtonsColor: string;
  themeBuyButtonsOption: string;
  themeCategoryThumbnails: string;
  themeComplementaryButtonColor: string;
  themeComplementaryIconColor: string;
  themeComplementaryStyle: string;
  themeCourseProgressColor1: string;
  themeCourseProgressColor2: string;
  themeCourseProgressStyle: string;
  themeCourseThumbnails: string;
  themeHeaderBackgroundColor: string;
  themeHeaderStyle: string;
  themeHeaderTextColor: string;
  themeMediaSpaceThumbnails: string;
  themeNavigationButtonsButtonColor: string;
  themeNavigationButtonsCompletedButtonColor: string;
  themeNavigationButtonsConfig: string;
  themeUserThumbnails: string;
}

export interface IGeneralTheme {
  themeOthersShowEnsinioBrand: string;
  themeDarkModeLogoHorizontal: string;
  themeDarkModeLogoIcon: string;
  themeDarkModeMasterColor: string;
  themeDarkModeOptions: "only_theme_option" | "inactive" | "active";
  themeDarkModeTextMasterColor: string;
  themeFavicon: string;
  themeFaviconCustom: string;
  themeLogoHorizontal: string;
  themeLogoIcon: string;
  themeLogoIconOptionsTopBar: string;
  themeLogoIconTopBar: string;
  themeLogoOptionsTopBar: string;
  themeLogoTopBar: string;
  themeMainMenu: string;
  themeMasterColor: string;
  themeMasterTextColor: string;
  themeSideBar: string;
  themeSideBarBackgroundColor: string;
  themeSideBarColapseIconBackgroundColor: string;
  themeSideBarColapseIconColorColor: string;
  themeSideBarItemColor: string;
  themeTopBar: string;
  themeTopBarBackgroundColor: string;
  themeTopBarIconsColor: string;
}
interface ISettings {
  ["advanced-theme"]: IAdvancedTheme;
  blog: any;
  bundles: any;
  collections: any;
  courses: any;
  dashboard: any;
  gamification: any;
  ["general-theme"]: IGeneralTheme;
  ["learning-paths"]: any;
  ["media-space"]: any;
  products: any;
  site: any;
  ["social-network"]: any;
  users: any;
  others: any;
}

export interface ICustomFieldsActive {
  label: string;
  name: string;
  placeholder: string;
  required: boolean;
}

export interface ICreateAccountOptions {
  custom_fields_active: ICustomFieldsActive[];
  request_phone_to_create_account: boolean;
  request_address_to_create_account: boolean;
  request_document_to_create_account: boolean;
  request_custom_fields_to_create_account: boolean;
}

export interface TenantData {
  active: boolean;
  country: {
    id: number;
    alpha2: string;
    alpha3: string;
    num: string;
    isd: string;
    name: string;
  };
  create_account_options: ICreateAccountOptions;
  created_at: string;
  currency: {
    id: number;
    name: string;
    name_code: string;
    code: number;
    precision: number;
    subunit: number;
    symbol: string;
  };
  email: string;
  full_name: string;
  id: number;
  langs: ILangs[];
  offers: {
    is_enabled: boolean;
    is_checkout_steps_required: boolean;
    is_checkout_onepage_enabled: boolean;
  };
  use_pixel: boolean;
  active_pixels: string[];
  use_conversion_api: boolean;
  pixels: IPixel[];
  settings: ISettings;
  soft_descriptor: string;
  updated_at: string;
  uuid: string;
  enabled_features: string[];
  video_folder?: string;
  subscription_status: string;
  plan: {
    name: string;
  }
  acquirer: {
    complement_min_value: boolean;
    min_value: number;
  };
}

const tenancy: TenantData = {} as TenantData;

export default tenancy;
